/**
 * 实名认证 — /user/api/realname
 * 供订阅服务、购买流程及其他页面共用。
 */
import Vue from "vue";
import request from "@/utils/request";

export const REALNAME_API_BASE = "/api/user/api/realname";

/** 0=未认证, 1=认证中, 2=已认证(终身绑定), 3=认证失败(可重试) */
export const REALNAME_STATUS = {
  UNVERIFIED: 0,
  PENDING: 1,
  VERIFIED: 2,
  FAILED: 3,
};

/** 实名认证全局状态（响应式，跨组件共享） */
export const realnameState = Vue.observable({
  loading: false,
  loaded: false,
  status: null,
});

let inflightStatusRequest = null;

/** 是否已完成实名认证 */
export function isRealnameVerified(status) {
  if (!status || typeof status !== "object") {
    return false;
  }
  if (status.verified === true) {
    return true;
  }
  return Number(status.realnameStatus) === REALNAME_STATUS.VERIFIED;
}

/** 是否应展示「去实名」等未实名提示（已拉取状态且未认证） */
export function shouldShowRealnameHint() {
  return realnameState.loaded && !isRealnameVerified(realnameState.status);
}

/** 查询实名状态 GET /status */
export function fetchRealnameStatus() {
  return request.get(`${REALNAME_API_BASE}/status`).catch(() => null);
}

/**
 * 三要素核验 POST /verify
 * @param {{ realName: string, idCard: string, phone?: string }} payload
 */
export function verifyRealname(payload = {}) {
  const { realName, idCard, phone } = payload;
  const params = { realName, idCard };
  if (phone != null && String(phone).trim() !== "") {
    params.phone = phone;
  }
  return request.post(`${REALNAME_API_BASE}/verify`, null, { params });
}

/** 拉取实名状态并更新 realnameState；silent=true 时不展示 loading；force=true 强制重新请求 */
export function refreshRealnameStatus(options = {}) {
  const { silent = realnameState.loaded, force = false } = options;

  if (!force && realnameState.loaded) {
    return Promise.resolve(realnameState.status);
  }

  if (inflightStatusRequest) {
    return inflightStatusRequest;
  }

  if (!silent) {
    realnameState.loading = true;
  }

  inflightStatusRequest = fetchRealnameStatus()
    .then((status) => {
      realnameState.status = status;
      realnameState.loaded = true;
      return status;
    })
    .catch(() => {
      if (!silent) {
        realnameState.status = null;
      }
      return realnameState.status;
    })
    .finally(() => {
      realnameState.loading = false;
      inflightStatusRequest = null;
    });

  return inflightStatusRequest;
}

/** 退出登录时清空实名状态，避免残留到下一账号 */
export function resetRealnameState() {
  realnameState.loading = false;
  realnameState.loaded = false;
  realnameState.status = null;
  inflightStatusRequest = null;
}



// WEBPACK FOOTER //
// ./src/view/user/realname/realnameService.js